import { SupplierPortalSettings } from '../../models/settings.model';

export interface SettingsState {
  settings: SupplierPortalSettings | null;
  isLoading: boolean;
  error: string | null;
}

export const initialSettingsState: SettingsState = {
  settings: null,
  isLoading: false,
  error: null
};
